export default __webpack_public_path__ + "static/media/Educacion.b1fca34c.svg";